import axios from 'axios';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';


export const closeTask = (taskID) => {
  const data = {taskID: parseInt(taskID, 10)};

  return axios.post(api.CLOSE_TASK, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

    })
    .catch((err) => {
      console.error('Close task returns error:');
      console.error(err);
    });
};
